'use client';

import { forwardRef } from 'react';
import { useTranslations } from 'next-intl';
import { H2Large } from './styleConstants';
import { useRef } from 'react';
import { useProgressInViewport } from '../../utils/useProgressInViewport';
import { CustomImage as Image } from '../shared';
import styles from './PersonaCardsSection.module.css';

const cx = (...classes: (string | undefined)[]) =>
  classes.filter(Boolean).join(' ');

const PersonaCard = forwardRef<
  HTMLDivElement,
  { className?: string; children?: React.ReactNode }
>(({ className, children }, ref) => (
  <div ref={ref} className={cx(styles.personaCard, className)}>
    {children}
  </div>
));
PersonaCard.displayName = 'PersonaCard';

export const PersonaCardsSection = () => {
  const t = useTranslations('home');
  const containerRef = useRef<HTMLDivElement>(null);
  const card1 = useRef<HTMLDivElement>(null);
  const card2 = useRef<HTMLDivElement>(null);
  const card3 = useRef<HTMLDivElement>(null);
  // const card4 = useRef<HTMLDivElement>(null);

  const SPEED = 150;

  useProgressInViewport({
    containerRef: containerRef,
    startsFromBottom: true,
    startAtZero: true,
    callback: (progress) => {
      if (
        !containerRef.current ||
        !card1.current ||
        !card2.current ||
        !card3.current ||
        // !card4.current ||
        (window.innerWidth as number) < 768
      )
        return;

      const relativeProgress = 1 - progress;
      if (relativeProgress <= 0) {
        card1.current.style.transform = 'translateY(0)';
        card2.current.style.transform = 'translateY(0)';
        card3.current.style.transform = 'translateY(0)';
        // card4.current.style.transform = 'translateY(0)';
        card1.current.style.opacity = '0';
        card2.current.style.opacity = '0';
        card3.current.style.opacity = '0';
        // card4.current.style.opacity = '0';
      }

      if (relativeProgress > 0) {
        const opa = `${Math.min(1, relativeProgress * 1.5)}`;
        card1.current.style.opacity = opa;
        card2.current.style.opacity = opa;
        card3.current.style.opacity = opa;
        // card4.current.style.opacity = opa;
        card1.current.style.transform = `translateY(${
          -relativeProgress * SPEED * 1
        }px)`;
        card2.current.style.transform = `translateY(${
          -relativeProgress * SPEED * 1.7
        }px)`;
        card3.current.style.transform = `translateY(${
          -relativeProgress * SPEED * 1
        }px)`;
        // card4.current.style.transform = `translateY(${
        //   -relativeProgress * SPEED * 1.7
        // }px)`;
      }
    },
  });

  return (
    <section className={`${styles.root} u-grid`}>
      <div className={styles.content}>
        <H2Large>{t('home.personaCardsSection.heading.madeForEveryone')}</H2Large>

        <div className={styles.cardsContainer} ref={containerRef}>
          <PersonaCard ref={card1} className={styles.smImgOfLeft}>
            <div className={styles.overlayGradient}></div>
            <Image
              src="web_v2/home/made-for-all/lose-weight-sustainably.webp/w_800"
              fill
              style={{ objectFit: 'cover' }}
              alt={t('home.personaCardsSection.image.weightManagementAlt')}
            />
            <div className={styles.textContent}>
              <h4>{t('home.personaCardsSection.title.loseWeight')}</h4>
              <p>{t('home.personaCardsSection.text.loseWeightDesc')}</p>
            </div>
          </PersonaCard>

          <PersonaCard ref={card2}>
            <div className={styles.overlayGradient}></div>
            <Image
              src="web_v2/home/made-for-all/1.webp/w_1000"
              fill
              style={{ objectFit: 'cover' }}
              alt={t('home.personaCardsSection.image.preDiabeticAlt')}
            />
            <div className={styles.textContent}>
              <h4>{t('home.personaCardsSection.title.metabolicDisorders')}</h4>
              <p>{t('home.personaCardsSection.text.metabolicDisordersDesc')}</p>
            </div>
          </PersonaCard>

          <PersonaCard ref={card3}>
            <div className={styles.overlayGradient}></div>
            <Image
              src="web_v2/home/made-for-all/improve-athletic-performance.webp/w_1000"
              fill
              style={{ objectFit: 'cover' }}
              alt={t('home.personaCardsSection.image.athleteAlt')}
            />
            <div className={styles.textContent}>
              <h4>{t('home.personaCardsSection.title.athleticPerformance')}</h4>
              <p>{t('home.personaCardsSection.text.athleticPerformanceDesc')}</p>
            </div>
          </PersonaCard>
          {/*
            <PersonaCard ref={card4}>
              <div className="overlay-gradient"></div>
              <Image
                src="web_v2/home/made-for-all/optimise-energy-levels.webp/w_1000"
                fill
                style={{ objectFit: 'cover' }}
                alt="energy-management"
              />
              <div className="text-content">
                <h4>Optimise energy levels and recovery</h4>
                <p>
                  Get sleep, body temperature and movement insights to improve
                  your recovery. Better recovery means better energy levels,
                  lower disease risk and higher cognitive performance.
                </p>
              </div>
            </PersonaCard> */}
        </div>
      </div>
    </section>
  );
};
